module.exports = __webpack_public_path__ + "static/media/plasticRoad.74c07c1d.png";